import { getConstant } from '../utils';

export const getDistribution = getConstant('GET_DISTRIBUTION');
export const getDistributions = getConstant('GET_DISTRIBUTIONS');
export const clearDistribution = getConstant('CLEAR_DISTRIBUTION');
export const addDistribution = getConstant('ADD_DISTRIBUTION');
export const updateDistribution = getConstant('UPDATE_DISTRIBUTION');
export const updateFeedingDistribution = getConstant('UPDATE_FEEDING_DISTRIBUTION');
export const updateFertilizerPrice = getConstant('UPDATE_FERTILIZER_PRICE');
